import { render, staticRenderFns } from "./AssessmentReRegisterCallback.vue?vue&type=template&id=1b72363f&scoped=true"
import script from "./AssessmentReRegisterCallback.vue?vue&type=script&lang=js"
export * from "./AssessmentReRegisterCallback.vue?vue&type=script&lang=js"
import style0 from "./AssessmentReRegisterCallback.vue?vue&type=style&index=0&id=1b72363f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b72363f",
  null
  
)

export default component.exports